<template>
  <div>
    <div class="block">
      <div :style="item" class="item">
        <transition name="el-fade-in-linear">
          <div class="box" style="margin-top: 40px; margin-bottom: 40px">
            <p class="boxh">七个助手</p>
          </div>
        </transition>
        <transition name="el-zoom-in-center">
          <div class="box">
            <p class="boxp">浙江中智经济技术服务有限公司旗下的一款泛人力资源服务平台。</p>
          </div>
        </transition>
      </div>
    </div>
    <div class="content">
      <h1>七个助手介绍</h1>
      <div class="box">
        <p>
          七个助手整合了人力资源管理的全部模块，打通人力资源管理所涉及的全流程，
          实现数字化、智能化人才管理数字基础设施，既能覆盖人力资源所有环节的端到端管理需求，
          又能满足企业特定的定制开发需求，与业务管理系统和外部资源有效对接。
          一体化HRSaaS系统满足企业人力资源数字化的全流程管控、全业务服务、全数据流通和全场景覆盖，
          极大提高企业人才管理效率。
        </p>
      </div>
      <h1>发展历程</h1>
      <div class="box">
        <p>
          中国国际技术智力合作集团有限公司（简称中智，英文缩写CIIC），总部位于北京，
          成立于1987年6月，是国务院国有资产监督管理委员会管理的国有重点骨干企业(中央企业)。
          中智作为中国领先的人力资源企业，是一家主营人力资源业的中央企业。
          中智拥有六大业务板块以及投融资平台、文化传播平台，以人力资源外包、人力资源管理咨询、
          招聘猎头灵活用工及BPO、培训、国际人力资源服务（含对外劳务合作、商事服务）、
          技术贸易业务六大板块为主业，创新发展知识产权等与人力资源主业相关度高、
          国家战略高度关注的新兴智力服务领域，增进作为国家智库的影响力。中智以创新转型、
          变革发展，人力资源与科技的深度融合，描绘“智领中国”新蓝图。
        </p>
        <p>
          浙江中智经济技术服务有限公司于2005年成立，致力于以人力资源外包为主的智力性服务，
          已在全国200余个城市开展了人力资源服务。浙江中智服务于包括华为、吉利、大华、今日头条、
          网易、苹果、英特尔、3M、壳牌、正泰、顺网科技、杭州大厦、贝达药业等知名企业在内的5000
          余家客户。在浙江省内设有杭州、宁波、温州、绍兴、嘉兴、金华、台州、湖州、衢州、舟山、
          丽水、余杭等分公司与子公司。
        </p>
      </div>
      <h1 style="margin-bottom:38px">联系我们</h1>
      <p>邮箱： hr12345@ciiczj.com</p>
      <p>电话：0571-8724 0093</p>
      <p>地址：杭州市下城区白石路318号</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "demo",
  data() {
    return {
      item: {
        backgroundImage:
          "url(" + require("../../assets/photo/we.png") + ")",
      },
    };
  },
  mounted() {
  },
  methods: {
    login() {
      this.$router.push({name: 'login'})
    },
    register() {
      this.$router.push({name: 'register'})
    }
  },
};
</script>

<style lang="less" scoped>
.item {
  width: 100%;
  height: 550px;
  padding-top: 150px;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;

  .s1 {
    height: 55px;
  }

  .box {
    text-align: center;

    .boxh {
      color: rgba(255, 255, 255, 1);
      font-size: 36px;
    }

    .boxp {
      color: rgba(255, 255, 255, 1);
      font-size: 28px;
    }
  }
}

.content {
  background-color: rgba(255, 255, 255, 1);
  width: 100%;
  padding: 100px 300px;

  h1 {
    color: rgba(245, 165, 64, 1);
    font-size: 36px;
    text-align: center;
  }

  .box {
    margin-top: 30px;
    margin-bottom: 100px;
    padding: 50px;
    border-radius: 5px;
    text-align: center;
    border: 2px solid rgba(245, 165, 64, 1);

    p {
      color: rgba(16, 16, 16, 1);
      font-size: 18px;
      text-align: left;
      text-indent: 2em;
    }
  }

  p {
    color: rgba(16, 16, 16, 1);
    font-size: 18px;
    text-align: center;
  }
}
</style>
